var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInquiry(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_199_13765)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25 9.625H13.75",
    stroke: "#858584",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 12.375H13.75",
    stroke: "#858584",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3438 18.5625H4.09664C4.01005 18.5626 3.92429 18.5456 3.84427 18.5126C3.76424 18.4795 3.69154 18.4309 3.63031 18.3697C3.56908 18.3085 3.52053 18.2358 3.48744 18.1557C3.45436 18.0757 3.43739 17.99 3.4375 17.9034V10.6562C3.4375 8.55938 4.27048 6.5484 5.75319 5.06569C7.2359 3.58298 9.24688 2.75 11.3438 2.75C12.382 2.75 13.4101 2.9545 14.3693 3.35183C15.3286 3.74915 16.2001 4.33152 16.9343 5.06569C17.6685 5.79985 18.2508 6.67143 18.6482 7.63066C19.0455 8.58989 19.25 9.61799 19.25 10.6562C19.25 11.6945 19.0455 12.7226 18.6482 13.6818C18.2508 14.6411 17.6685 15.5126 16.9343 16.2468C16.2001 16.981 15.3286 17.5633 14.3693 17.9607C13.4101 18.358 12.382 18.5625 11.3438 18.5625Z",
    stroke: "#858584",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_199_13765"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInquiry);
export default __webpack_public_path__ + "static/media/Inquiry.1954b101d197769691a84d5a5313050c.svg";
export { ForwardRef as ReactComponent };